import { Component, OnInit } from '@angular/core';
import { NavigateService } from '../../service/navigate.service';
import { ActivatedRoute } from '@angular/router'
declare var $: any;
@Component({
    selector: 'app-about-index-detail',
    templateUrl: './about-index-detail.component.html',
    styleUrls: ['./about-index-detail.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class AboutIndexDetailComponent implements OnInit {
    data:any={};
    fun:any
    constructor(private navigateService: NavigateService,private route: ActivatedRoute) {
        
    }

    //初始化;
    ngOnInit() {
         this.data=JSON.parse(this.route.snapshot.queryParams.data)
         window.scrollTo(0,0)
        this.fun=()=>{
            console.log('event')
            let event=new Event('look')
            window.dispatchEvent(event)
        }
        window.addEventListener("popstate", this.fun, false);
    }
    ngOnDestroy() {
        window.removeEventListener('popstate', this.fun)
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/about/about-index-detail/about-index-detail.component.ts